import { useMemo } from 'react';
import { formatSnakeCaseToGeneral, useQuery } from '@common-fe/common-fe';
import { capitalize, toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export enum BeneficiaryRelationship {
  SPOUSE = 'SPOUSE',
  PARTNER = 'PARTNER',
  CHILD = 'CHILD',
  PARENT = 'PARENT',
  DEPENDENT = 'DEPENDENT',
  GUARDIAN = 'GUARDIAN',
  TRUST = 'TRUST',
  ESTATE = 'ESTATE',
  OTHER = 'OTHER',
}

export interface BeneficiaryRelationshipTypePayload {
  id: number;
  name: BeneficiaryRelationship;
}

export interface BeneficiaryRelationshipType {
  id: string;
  name: BeneficiaryRelationship;
  key: BeneficiaryRelationship;
  value: BeneficiaryRelationship;
  title: string;
}

const useBeneficiaryRelationshipsTypesQuery = () => {
  const { isLoading, isSuccess, isError, data } = useQuery(
    [API_URL.ENUMS_BENEFICIARY_RELATIONSHIP_TYPES],
    () => api.get(API_URL.ENUMS_BENEFICIARY_RELATIONSHIP_TYPES)
  );

  const formattedRelationshipsTypes = useMemo(
    () =>
      data?.data?.map((item) => ({
        id: toString(item?.id),
        name: item?.name || '',
        key: item?.name || '',
        value: item?.name || '',
        title: capitalize(formatSnakeCaseToGeneral(item.name || '')),
      })),
    [data]
  );

  return {
    data: data?.data || [],
    formattedRelationshipsTypes,
    isError,
    isLoading,
    isSuccess,
  };
};

export default useBeneficiaryRelationshipsTypesQuery;
